var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 19,
    viewBox: "0 0 91 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7918_141336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9837 0L11.3467 6.7355L10.0948 4.91783L13.4799 0H11.627L9.1699 3.572L6.70969 0H4.85674L8.24187 4.91783L6.98996 6.7355L2.35295 0H0.5L6.98996 9.42717L9.1699 6.26367L11.3467 9.42717L17.8367 0H15.9837Z",
    fill: "#00A196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98996 9.42719L0.5 18.8512H2.35295L6.98996 12.1189L8.24187 13.9365L4.85674 18.8512H6.70969L9.1699 15.2824L11.627 18.8512H13.4799L10.0948 13.9365L11.3467 12.1189L15.9837 18.8512H17.8367L11.3467 9.42719L9.1699 12.5907L6.98996 9.42719Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8661 12.084H31.7664L29.1256 3.77148H27.7616L25.1208 12.084H25.0211L22.5329 3.77148H20.437L23.9965 15.0828H25.9055L28.3408 7.51132H28.4436L30.8789 15.0828H32.7879L36.3474 3.77148H34.3543L31.8661 12.084Z",
    fill: "#00A196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7355 10.0415H45.4939V8.30932H40.7355V5.50365H47.8576V3.77148H38.8296V15.0828H48.2656V13.3507H40.7355V10.0415Z",
    fill: "#00A196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6081 11.0548H57.5738L53.2264 3.77148H51.2676V15.0828H53.0894V7.39098H53.1735L57.3527 14.345H57.661L61.8402 7.39098H61.9243V15.0828H63.8333V3.77148H61.9586L57.6081 11.0548Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2708 10.0415H74.0293V8.30932H69.2708V5.50365H76.3899V3.77148H67.3618V15.0828H76.7978V13.3507H69.2708V10.0415Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7724 9.17382L90.151 3.77148H87.834L84.6326 7.89448L81.5652 3.77148H79.1299L83.3869 9.26249L78.6689 15.0828H80.9859L84.5298 10.5418L87.9368 15.0828H90.3721L85.7724 9.17382Z",
    fill: "#595757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7918_141336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 19,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec2c35cb448537025fe7e851323c75a6.svg";
export { ForwardRef as ReactComponent };